import { Select, styled } from '@mui/material';

export const RoleSelect = styled(Select)(({ theme }) => ({}));
